import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./trainers.css";
import trainerImg from "../../assets/testingimages/otherimages/ourtraining.jpg";

function Trainers() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="trainers-section">
      <div className="container">

        <section>
          <div className="headlines-for-all" data-aos="fade-up">
            <h4>
              <span>Our </span> Trainers
            </h4>
          </div>
        </section>

        <div className="trainers-content">

          {/* Left text area */}
          <div className="trainers-text">
            <p data-aos="fade-up" data-aos-delay="100">
              At{" "}
              <strong>
                <span className="fazo-fazo"> Fazo Academy </span>
              </strong>
              , we are committed to delivering a{" "}
              <strong>
                comprehensive blend of theoretical knowledge and practical skills
              </strong>{" "}
              in UI/UX Design through our expertise in{" "}
              <strong>industry-focused training</strong>.
            </p>

            <p data-aos="fade-up" data-aos-delay="200">
              Our <strong>experienced UI/UX instructors</strong> specialize in{" "}
              <strong>user experience design, interface design, and usability principles</strong>{" "}
              techniques, ensuring students develop{" "}
              <strong>real-world UI/UX expertise</strong>.
            </p>

            <p data-aos="fade-up" data-aos-delay="300">
              Students gain hands-on experience with{" "}
              <strong>various UI/UX tools and technologies</strong>, including{" "}
              <strong>
                Figma, Adobe XD, Photoshop, Illustrator, Wireframing, and Prototyping tools.
              </strong>
            </p>

            <p data-aos="fade-up" data-aos-delay="400">
              Our <strong>specialized training programs</strong> cover industry-leading
              design concepts and tools like{" "}
              <strong>
                User Research, Information Architecture, Interaction Design, Design Systems,
                and Usability Testing
              </strong>
              , enabling students to become proficient in{" "}
              <strong>creating user-friendly digital experiences</strong>.
            </p>

            <p data-aos="fade-up" data-aos-delay="500">
              Our <strong>dedicated UI/UX trainer</strong> designs personalized training
              modules that include{" "}
              <strong>
                real-time design projects, case studies, portfolio building, prototyping,
                and interview preparation
              </strong>{" "}
              through hands-on creative sessions.
            </p>
          </div>

          {/* Right image */}
          <div className="trainers-image">
            <img
              src={trainerImg}
              alt="Trainers"
              data-aos="zoom-in"
              data-aos-delay="300"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Trainers;
